import StepConfirmMeter from './StepConfirmMeter';
import { useTranslation } from 'react-i18next';
export const STEP_NO_ACCESS_METER_ID = 'step-no-access-meter';
export default function StepNoAccessMeter() {
  const { t } = useTranslation();
  return (
    <StepConfirmMeter
      message={t('step.no.access.meter.message')}
      description={t('step.no.access.meter.description')}
      actionLabel={t('step.no.access.meter.btn.label')}
    ></StepConfirmMeter>
  );
}
